// extracted by mini-css-extract-plugin
export var containerBox = "index-module--containerBox--bJ6mY";
export var imgContainer = "index-module--imgContainer--ve1p0";